<template>
  <div>
    <v-layout>
      <v-flex>
    <!-- <v-container fluid> -->
        <h2 class="my-2">Forgot your password?</h2>
        <v-card color="cardgray">
          <v-container>
            <p>Please submit the email address you used to register your account. Then we will send you a link to reset your password. Click the link in the email message and then return here to login with your new password. If you cannot access your registered email and you have forgotten your password, you will need to create a new account.</p>
          </v-container>

          <v-container>
            <v-form
                v-model="valid"
                ref="form"
                lazy-validation
              >
              <v-text-field
                name="email"
                label="Email"
                v-model="emailAddress"
                :rules="emailRules"
                type="text"
                required
              ></v-text-field>

              <v-btn
                @click="resetPw"
                :disabled="!valid"
                color="primary"
              >
                Submit
              </v-btn>
              <v-btn @click="clear">clear</v-btn>

            </v-form>
          </v-container>

<!--           <v-container>
            <p>Please enter the email address you used to register your account. We will send you a link to reset your password. Click the link in the email message, then return here to login with your new password. If you cannot access your registered email and you have forgotten your password, you will need to create a new account.</p>
            <input type="text" v-model="emailAddress" placeholder="Enter email address here"><br>
            <v-divider class="my-3"></v-divider>
            <v-btn color="primary" v-on:click="resetPw">Reset</v-btn>
            <v-btn flat color="primary" to="login">Return to login</v-btn>
            
            <h4 v-if='emailSent'>Password reset link sent, please check your email.</h4>
            <h4 v-if='errorMessage'>Error: {{ errorMessage }}</h4>


          </v-container> -->
        </v-card>
      </v-flex>
    </v-layout>
    <!-- </v-container> -->
  </div>
</template>

<script>
// import axios from 'axios'
import firebase from 'firebase'

export default {
  name: 'ForgotPassword',
  data: function () {
    return {
      errorMessage: null,
      emailAddress: '',
      emailSent: false,
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /\S+@\S+\.\S+/.test(v) || 'E-mail must be valid' // anystring@anystring.anystring
      ]
    }
  },
  methods: {
    resetPw: function () {
      // var context = this
      // console.log(context)
      // console.log('Password reset method not implemented yet.')
      // console.log(this)
      console.log('email: ' + this.emailAddress)
      // console.log('email: ' + this.email)
      var auth = firebase.auth()

      auth.sendPasswordResetEmail(this.emailAddress)
      .then(() => {
        // Email sent message
        this.$set(this.$data, 'emailSent', true)
        this.logout()
      })
      .catch((error) => {
        // An error happened
        console.log('Error: ' + error)
        this.$set(this.$data, 'errorMessage', error)
      })
      .then(this.$router.push('reset-password-confirmation'))
    },
    clear () {
      this.$refs.form.reset()
    },
    logout: function () {
      firebase.auth().signOut()
      // .then(() => {
      //   this.$router.replace('login')
      //   .then(function () {
      //     console.log('Signed out, goodbye.')
      //   })
      // })
      // .catch(function (err) {
      //   console.log('Something went wrong while logging out: ', err.message)
      // })
    }
  }
}
</script>

<style scoped>
  .signUp {
    margin-top: 40px;
  }
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 10px;
    width: 10%;
    cursor: pointer;
  }
  span {
    display: block;
    margin-top: 20px;
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/User/ForgotPassword.vue